export enum CURRENCY_TYPE {
  THB = 'THB',
  USD = 'USD',
}
